import Queue from "nq-js";

class SignOutUseCase {
  execute() {
    return new Queue.User().signOut();
  }
}

export default SignOutUseCase;
